<wl-hero
  [hero]="hero()"
  [hasWidget]="hasWidget()"
  [hasAsset]="hasAsset()"
  [hasEssentRebranding]="enableEssentRebranding"
/>
